<template>
  <section class="content">
    <loader v-show="loading"></loader>
    <vuetable
      v-show="!loading"
      v-on:table-delete-request="deleteEntity"
      v-on:table-edit-request="handleEdit"
      :showEdit="true"
      :showDelete="true"
      :tableData="tableData"
      :tableTitle="'Party Groups'"
      :fields="[{ header: 'Name', prop: 'name', hideByDefault: false }]"
      v-on:pages-remaining="loadMore"
      :maxItems="maxValue"
    ></vuetable>
  </section>
</template>
<script>
  import vuetable from '../../../helpers/VueTable.vue'
  import Loader from '../../../helpers/Loader.vue'
  import AdminSearchResults from '../../mixins/AdminSearchResultsMixin.js'
  export default {
    name: 'PartyGroupSearchResults',
    components: {
      vuetable: vuetable,
      Loader
    },
    mixins: [ AdminSearchResults ],
    data () {
      return {
        loading: false,
        tableData: [],
        entityName: 'party-group',
        editEntityScreen: 'Admin - Edit/View Party Group'
      }
    },
    methods: {
      postDeleteRoutine () {
        this.$store.dispatch('systemOption/loadPartyGroups', { forceReload: true })
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// PartyGroupSearchResults.vue?52d98cde